import React, { useState } from 'react';
import '../App.css';

const PasswordScreen = ({ onPasswordCorrect }) => {
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        // Hardcoded password for now, as per plan
        if (password.toUpperCase() === 'PARABUL') {
            onPasswordCorrect();
        } else {
            setError('Hatalı şifre! Story\'e bakmayı unutma 😉');
            setPassword('');
        }
    };

    const openInstagram = () => {
        window.open('https://www.instagram.com/parabulturkiye', '_blank');
    };

    return (
        <div className="password-screen">
            <div className="neon-box">
                <h2>🔒 Şifreli Giriş</h2>
                <p>Oyuna girmek için bugünün şifresini girmen gerekiyor.</p>

                <div className="hint-box">
                    <p>🕵️‍♂️ Şifre nerede?</p>
                    <button className="instagram-btn" onClick={openInstagram}>
                        📸 @parabulturkiye Story'sine Bak
                    </button>
                </div>

                <form onSubmit={handleSubmit}>
                    <input
                        type="text"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Şifreyi buraya yaz..."
                        className="neon-input"
                        autoFocus
                    />
                    {error && <p className="error-text">{error}</p>}

                    <button type="submit" className="neon-btn primary full-width">
                        🔓 Giriş Yap
                    </button>
                </form>
            </div>
        </div>
    );
};

export default PasswordScreen;
